import React from 'react'

// A nice looking 404 page
function NotFound() {
  return (
    <div style={{ textAlign: 'center', marginTop: '50px' }}>
      <h1>404 Not Found</h1>
      <p>Sorry, the page you were looking for could not be found.</p>
    </div>
  )
}

export default NotFound
